import axios from "@/api/axiosInstance";
import { ListCoursesRequest, ListCoursesResponse } from "./types";

export const listCourses = async (
  params: ListCoursesRequest = {},
): Promise<ListCoursesResponse> => {
  const response = await axios.get<ListCoursesResponse>(
    "/api/private/learning-center/courses",
    {
      params: {
        search: params.search ?? undefined,
        status: params.status ?? undefined,
        page: params.page,
        pageSize: params.pageSize,
        sortBy: params.sortBy,
        sortOrder: params.sortOrder,
      },
    },
  );
  return response.data;
};
